define.alias("shared/components/shared/post-tagging/badge", "preview-grid/components/shared/post-tagging/badge");